import InfiniteScroll from "react-infinite-scroll-component";
import { t } from "@/i18n-js/instance";
import { useNearMeFilter } from "@/react/components/shared/MemberFilters/SharedFilters/NearMe/useNearMeFilter";
import { LoaderRow } from "@circle-react/components/shared/LoaderRow";
import { Typography } from "@circle-react-uikit/Typography";
import type { UseSelectMembersInfiniteQuery } from "../hooks/useSelectMembersInfiniteQuery";
import { CommunityMember as CommunityMemberV2 } from "./CommunityMemberV2/CommunityMember";

interface ListViewProps {
  memberDataParams: UseSelectMembersInfiniteQuery;
  shouldShowConnectionStatus?: boolean;
  shouldShowHiddenMemberTooltip: boolean;
}

export const ListView = ({
  memberDataParams,
  shouldShowHiddenMemberTooltip,
}: ListViewProps) => {
  const { isActiveQuery, dataLength, fetchNextPage, hasNextPage, members } =
    memberDataParams;

  const { nearMeFilter, isNearMeActive } = useNearMeFilter();

  return (
    <div className="member-directory-members">
      {isActiveQuery && (
        <div
          className="member-directory-members__count"
          data-testid="members-directory-count"
        >
          {isNearMeActive ? (
            <>
              <Typography.LabelSm weight="medium">
                {t("member_directory.near_me.title", {
                  count: dataLength,
                })}
              </Typography.LabelSm>
              <Typography.BodyXs>{nearMeFilter?.value?.name}</Typography.BodyXs>
            </>
          ) : (
            t("members_directory.header.search.members_found", {
              count: dataLength,
            })
          )}
        </div>
      )}
      <InfiniteScroll
        style={{ overflow: "initial" }}
        scrollThreshold={0.5}
        next={fetchNextPage}
        hasMore={!!hasNextPage}
        loader={<LoaderRow />}
        dataLength={members.length}
        scrollableTarget="panel"
      >
        <ul
          className="flex list-none flex-col gap-y-4"
          data-testid="directory_members_list"
        >
          {members.map(communityMember => (
            <CommunityMemberV2
              communityMember={communityMember}
              key={communityMember.id}
              shouldShowHiddenMemberTooltip={shouldShowHiddenMemberTooltip}
            />
          ))}
        </ul>
      </InfiniteScroll>
    </div>
  );
};
